import React from 'react';
import { Box, List, ListItemButton } from '@mui/material';

function DeleteProxy({ node, handleClose, onRemoveProxy, setError }) {
  const getPerson = (x) => {
    if (!x) return undefined;
    if (x?.pid) return x;
    if (x?.data?.pid) return x.data;
    return undefined;
  };

  const menuPerson = getPerson(node);

  const deleteProxyNow = () => {
    const originalPid = menuPerson?.proxyOf;
    const proxyId = (menuPerson?.spouseIds || [])[0];

    if (originalPid == null || proxyId == null) {
      setError?.('Remove Proxy: proxy is missing required references.');
      return;
    }

    onRemoveProxy?.({ originalPid, proxyId });
    handleClose?.();
  };

  return (
    <Box>
      <List>
        <ListItemButton onClick={deleteProxyNow}>Remove Proxy</ListItemButton>
      </List>
    </Box>
  );
}

export default DeleteProxy;
